import { NgModule } from '@angular/core';
import {
	MatToolbarModule,
	MatInputModule,
	MatButtonModule,
	MatSidenavModule,
	MatIconModule,
	MatListModule,
	MatDialogModule,
	MatGridListModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatRadioModule,
	MatBottomSheet,
} from '@angular/material'
import { LayoutModule } from '@angular/cdk/layout'
import { MatChipsModule } from '@angular/material/chips'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSelectModule } from '@angular/material/select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatMenuModule } from '@angular/material/menu'
import { MatSliderModule } from '@angular/material/slider'
import { MatTabsModule } from '@angular/material/tabs'
import {MatStepperModule} from '@angular/material/stepper';


import {MatDatepickerModule} from '@angular/material/datepicker';
@NgModule({
	imports: [
        MatCheckboxModule,
		MatToolbarModule,
		MatButtonModule,
		MatSidenavModule,
		MatIconModule,
		MatListModule,
		LayoutModule,
		MatChipsModule,
		MatDialogModule,
        MatFormFieldModule,
        MatStepperModule,
		MatInputModule,
		MatGridListModule,
		MatExpansionModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		MatMenuModule,
		MatSliderModule,
        MatTabsModule,
        MatPaginatorModule,
		MatRadioModule, 
		MatDatepickerModule
	],
	exports: [
        MatCheckboxModule,
        MatRadioModule,
        MatToolbarModule,
        MatPaginatorModule,
		MatButtonModule,
		MatSidenavModule,
		MatIconModule,
		MatListModule,
		LayoutModule,
		MatChipsModule,
		MatDialogModule,
        MatFormFieldModule,
        MatStepperModule,
		MatInputModule,
		MatGridListModule,
		MatExpansionModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		MatMenuModule,
		MatSliderModule,
		MatTabsModule,
		MatDatepickerModule
	],
})
  export class Material { }